module.exports = __webpack_public_path__ + "static/media/teamwork-green.691fb3f0.svg";